import {
    Badge,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow
} from "@fluentui/react-components";
import {formatDateForTitle, getFormatForTimeValue, getMillisecondsFormat} from "../handlers/datehandler";
import {isScheduleItemFinished} from "../handlers/schedulehandler";

const ScheduleItemForView = ({ scheduleItem }) => {

    const getParticipantsByStartNR = (startNR) => {
        const participants = scheduleItem.participants;
        const foundParticipants = participants.find((p) => parseInt(p.start_nr) === parseInt(startNR));
        return (!foundParticipants) ? "" : getParticipantString(foundParticipants.participants);
    }

    const getTime = (dateTime) => {
        const diffMs = new Date(dateTime) - new Date(scheduleItem.race_start_time);

        const hours = Math.floor(diffMs / 3_600_000);
        const minutes = Math.floor((diffMs % 3_600_000) / 60_000);
        const seconds = Math.floor((diffMs % 60_000) / 1_000);
        const milliseconds = diffMs % 1_000;

        return `${getFormatForTimeValue(hours)}:${getFormatForTimeValue(minutes)}:${getFormatForTimeValue(seconds)}.${milliseconds.toString().padStart(3, '0')}`;
    }

    return (
      <>
          <div className={`flex flex-column flex-gap-medium`}>
              <div className={`flex flex-gap-medium flex-align-center flex-wrap`}>
                  {
                      scheduleItem.race_start_time && !isScheduleItemFinished(scheduleItem) &&
                      <>
                          <Badge appearance="filled" color="warning">
                              Started
                          </Badge>
                      </>
                  }
                  {
                      isScheduleItemFinished(scheduleItem) &&
                      <>
                          <Badge appearance="filled" color="success">
                              Finished
                          </Badge>
                      </>
                  }
                  <h3>{ getTitleString(scheduleItem) }</h3>
              </div>
              <Table
                style={{tableLayout: "fixed"}} >
                  <TableHeader>
                      <TableRow>
                          <TableHeaderCell
                            style={{ width: 25 }}
                          >
                              {
                                  <b>NR</b>
                                  // isScheduleItemFinished(scheduleItem) ?
                                  //     <b>Pos.</b>
                                  //     :
                                  //     <b>Startnr</b>
                              }
                          </TableHeaderCell>
                          {
                              isScheduleItemFinished(scheduleItem) ?
                                  <TableHeaderCell
                                      style={{ width: 100 }}
                                  >
                                      {
                                          isScheduleItemFinished(scheduleItem) &&
                                          <b>Tijd</b>
                                      }
                                  </TableHeaderCell>
                                  : null
                          }

                          <TableHeaderCell
                            style={isScheduleItemFinished(scheduleItem) ? { width: `calc(100% - 130px)` } : { width: `calc(100% - 25px)` }}
                          >
                              <b>Deelnemers</b>
                          </TableHeaderCell>
                      </TableRow>
                  </TableHeader>
                  <TableBody>
                      {
                          (isScheduleItemFinished(scheduleItem)) ? <>
                          {
                              scheduleItem.results.map((result, index) => (
                                  <TableRow key={index}>
                                      <TableCell>
                                          { index + 1 }
                                      </TableCell>
                                      <TableCell>
                                          {
                                              isNaN(result.order) ?
                                                  result.order :
                                                  getTime(result.finish_time)
                                          }
                                      </TableCell>
                                      <TableCell>
                                          { getParticipantsByStartNR(result.start_nr) }
                                      </TableCell>
                                  </TableRow>
                              ))
                          }
                          </> :
                              <>
                                  {
                                      scheduleItem.participants.map((participant, index) => (
                                          <TableRow key={index}>
                                              <TableCell>
                                                  {participant.start_nr}
                                              </TableCell>
                                              <TableCell>
                                                  {getParticipantString(participant.participants)}
                                              </TableCell>
                                          </TableRow>
                                      ))
                                  }
                              </>
                      }
                  </TableBody>
              </Table>
          </div>
      </>
    );
}

export default ScheduleItemForView;

export const getTitleString = (scheduleItem) => {
    if (!scheduleItem) {
        return ``;
    }
    return `Race ${scheduleItem.race_nr} - ${formatDateForTitle(scheduleItem.planned_start_time)} - ${scheduleItem.boat?.boat} - ${scheduleItem.gender?.gender} - ${scheduleItem.category?.category} - ${scheduleItem.distance?.distance}${scheduleItem.race_type ? ` - ${scheduleItem.race_type}` : ``}`;
}

export const getParticipantString = (participants) => {
    return participants.map(participant => participant.first_name + " " + participant.last_name + " - " + participant.short_club_name).join(`, `);
}